import React from 'react';
import PageDetail from './PageDetail';

const PartyDetail = (props) => {
  return <PageDetail tag='PARTY' url='/party-selection' id={props.match.params.id}/>;
}

export default PartyDetail;